import { Fragment } from 'react';
import { Container } from '@/components/container';
import { Toolbar, ToolbarActions, ToolbarDescription, ToolbarHeading, ToolbarPageTitle } from '@/partials/toolbar';
import { PageNavbar } from '@/pages/account';
import { AccountTeamsStarterContent } from '.';
import { useLayout } from '@/providers';
const AccountTeamsStarterPage = () => {
  const {
    currentLayout
  } = useLayout();
  return <Fragment>
      <PageNavbar />

      {currentLayout?.name === 'demo1-layout' && <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle />
              <ToolbarDescription>
                Efficient team organization with real-time updates
              </ToolbarDescription>
            </ToolbarHeading>
            <ToolbarActions>
              <a href="#" className="btn btn-sm btn-light">
                Plans
              </a>
            </ToolbarActions>
          </Toolbar>
        </Container>}

      <Container>
        <AccountTeamsStarterContent />
      </Container>
    </Fragment>;
};
export { AccountTeamsStarterPage };